/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".img-header-page[_ngcontent-%COMP%]{margin-left:40px;width:100px;-o-object-position:center;object-position:center;-o-object-fit:cover;object-fit:cover;flex-grow:0;cursor:pointer}"];
export { styles as styles };
